export interface UserOption {
    label: string;
    value: string;
}

export enum SymbologyValues {
    'Instinet' = 'Instinet',
    'Bloomberg' = 'Bloomberg',
    'CUSIP' = 'CUSIP',
    'Local' = 'Local',
    'SEDOL' = 'SEDOL',
}

export const symbologyOptions = [
    { label: 'Instinet', value: SymbologyValues.Instinet },
    { label: 'Bloomberg', value: SymbologyValues.Bloomberg },
    { label: 'CUSIP', value: SymbologyValues.CUSIP },
    { label: 'Local Symbol Country', value: SymbologyValues.Local },
    { label: 'SEDOL', value: SymbologyValues.SEDOL },
];

export const currencyOptions = [
    { label: 'AUD', value: 'AUD' },
    { label: 'CAD', value: 'CAD' },
    { label: 'CHF', value: 'CHF' },
    { label: 'EUR', value: 'EUR' },
    { label: 'GBP', value: 'GBP' },
    { label: 'HKD', value: 'HKD' },
    { label: 'JPY', value: 'JPY' },
    { label: 'USD', value: 'USD' },
];

export interface AppSettingsState {
    alwaysShowMenuBar: boolean;
    currencyCode: string;
    symbology: SymbologyValues;
    combineSellsAndShorts: boolean;
    showBuysAsPositive: boolean;
    hideTooltips: boolean;
    hideChartHelp: boolean;
    hideAppToolbar: boolean;
}

export const initialAppSettingsState: AppSettingsState = {
    alwaysShowMenuBar: true,
    currencyCode: 'USD',
    symbology: symbologyOptions[1].value,
    combineSellsAndShorts: true,
    showBuysAsPositive: false,
    hideTooltips: false,
    hideChartHelp: false,
    hideAppToolbar: false,
};

export const mapUserOptionsToDropdown = (options: UserOption[]) =>
    options.map((o) => ({ text: o.label, value: o.value }));
